import {grid, gridItem} from '~/design-system/foundations'
import StandardTable, {
  type StandardTableProps,
  type StandardTableRow,
} from './_components/StandardTable'

export type HgTableProps = {
  caption?: React.ReactNode
  subtitle?: React.ReactNode
} & StandardTableProps

export type HgTableRow = StandardTableRow

export default function HgTable({
  rows,
  caption,
  columnTitles,
  subtitle,
  lastColumnAlignment,
  asymmetrical = false,
}: HgTableProps) {
  return (
    <div className="w-full">
      <div className={grid({className: 'mx-auto pt-s9'})}>
        {subtitle && (
          <h2
            className={gridItem({
              size: 'max',
              className: 'pb-s4 text-text-default arcadia-subheading-5',
            })}
          >
            {subtitle}
          </h2>
        )}
        <StandardTable
          rows={rows}
          columnTitles={columnTitles}
          lastColumnAlignment={lastColumnAlignment}
          asymmetrical={asymmetrical}
          className={gridItem({size: 'max'})}
        />
        {caption && (
          <small className="col relative col-span-full mt-s3 w-full text-left arcadia-body-3 before:absolute before:-left-[1ch] before:content-['*'] md:col-span-6 lg:col-start-3 3xl:col-span-4 3xl:col-start-3">
            {caption}
          </small>
        )}
      </div>
    </div>
  )
}
